
import { ValidateEmail, PLAN_LABELS } from "../utils/helpers.js";
import { alertas } from "./alerts.js";
import { login_members, closeOtherSession, view_details_memebrs } from "../api/api_members.js";

import { 
  check_payments_recibidos, 
  detalles_cliente, 
  new_qr_guide_reference,
  get_qr_guides,
  update_payments_config,
  send_email_forgot_password
   } from "../api/dashboards/api_dashboards_members.js";

import { store } from "../store/store.js";

import { makeQR } from "../utils/helpers.js";



export function view_login_members(){

document.getElementById("content_general").innerHTML = ` 



 <img src="https://cozumel-reef-maps.com.mx/Views/Default/img/logo_small.png" style="width:80px;"><br>

  <!-- FORMULARIO REAL: onsubmit llama a login_members() y retorna false para que no recargue la página.
       Mantuvimos la llamada original en el <a> por compatibilidad (opción A). -->
  <form id="membersLoginForm" onsubmit="login_members(); return false;" autocomplete="on">

    <div style="text-align: left;margin: 2%;width: 100%; background-color: #3d3f4117; padding: 10px;border-radius: 10px;" class="form form-inlne" >

      <div style="width: 100%;">Email:</div>
      <input style="height:auto;" type="email" id="email_login_members" name="email" class="form-control" placeholder="Enter Your Email*" required autocomplete="username" />

    </div><br>

    <div style="text-align: left;margin: 2%; width: 100%; background-color: #3d3f4117; padding: 10px;border-radius: 10px;" class="form form-inlne">

      <div style="width: 100%;">Password:</div>
      <input style="height:auto;" type="password" id="password_login_members" name="password" class="form-control" placeholder="Enter Your Password*" required autocomplete="current-password" />

    </div><br>

    <div id="div_button_login_start" style="text-align: left;margin: 2%;width: 100%;" class="form form-inlne" >
      <a onclick="login_members()" class="btn sub-btn" style="width: 100%; text-align: center; font-size: 18px; background-color: #f9cf40;">
        Login Now!
      </a>                
    </div>

  </form>

  <div id="response_server"></div>

<br><hr><br>

   <div style="text-align: left;margin: 2%;width: 100%; float:left;" class="form form-inlne">

 

      <a href="https://cozumel-reef-maps.com.mx/Dashboard_Members/register" class="btn plan-btn" style="width: 95%; padding: 15px 10px 15px 10px; text-align:center;">
          Create Account
      </a>                
    </div>


    <div style="text-align: left;margin: 2%;width: 50%; float:right;" class="form form-inlne" >
      <a onclick="forgot_password_member()" class="btn sub-btn" style="width: 100%; text-align: center; font-size: 15px; background-color: transparent; border: 1px solid;">
          Forgot password
      </a>                
    </div>
 

`;

}







export function other_session_open_alert() {

    // Eliminar popup anterior si existe
    const old = document.getElementById("iosPopupOverlay");
    if (old) old.remove();

    // Crear estilos con JS
    const style = document.createElement("style");
    style.innerHTML = `
        #iosPopupOverlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.45);
            backdrop-filter: blur(6px);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 99999;
            animation: fadeIn 0.2s ease-out;
        }

        #iosPopupCard {
            position: relative;
            background: #ffffff;
            width: 85%;
            max-width: 350px;
            padding: 25px 22px 22px 22px;
            border-radius: 18px;
            text-align: center;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto;
            animation: slideUp 0.25s ease-out;
        }

        #iosPopupCard h2 {
            margin: 0 0 10px 0;
            font-size: 20px;
            color: #111;
            font-weight: 600;
        }

        #iosPopupCard p {
            font-size: 16px;
            color: #444;
        }

        .iosBtn {
            margin-top: 18px;
            background: #007AFF;
            color: white;
            padding: 12px;
            width: 100%;
            border-radius: 12px;
            border: none;
            font-size: 16px;
            cursor: pointer;
            font-weight: 500;
        }

        .iosCloseBtn {
            position: absolute;
            top: 10px;
            left: 10px;
            background: rgba(0,0,0,0.08);
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            font-size: 18px;
            color: #333;
            user-select: none;
        }

        .iosCloseBtn:hover {
            background: rgba(0,0,0,0.15);
        }

        @keyframes fadeIn {
            from { opacity: 0; }
            to   { opacity: 1; }
        }

        @keyframes slideUp {
            from { transform: translateY(40px); opacity: 0; }
            to   { transform: translateY(0); opacity: 1; }
        }
    `;
    document.head.appendChild(style);

    // Crear overlay
    const overlay = document.createElement("div");
    overlay.id = "iosPopupOverlay";

    // Crear tarjeta
    const card = document.createElement("div");
    card.id = "iosPopupCard";

    // Botón de cerrar
    const closeBtn = document.createElement("div");
    closeBtn.className = "iosCloseBtn";
    closeBtn.innerHTML = "✕";
    closeBtn.onclick = () => overlay.remove();

    // Título y texto
    card.innerHTML = `
        <h2>Active Session Detected</h2>
        <p>There is an active session on another device.</p>

        <div id="response_session_detected"></div>
    `;

    // Botón principal
    const button = document.createElement("button");
    button.className = "iosBtn";
    button.innerText = "Open on this device";
    button.onclick = function() {
        closeOtherSession();
    };

    // Insertar contenido
    card.appendChild(closeBtn);
    card.appendChild(button);
    overlay.appendChild(card);
    document.body.appendChild(overlay);
}











export function forgot_password_member(){

document.getElementById("content_general").innerHTML = ` 

  <div style="width:100%; text-align:left;">
    <a onclick="view_login_social()" class="btn sub-btn"> ◀️ Back </a>
  </div>

We will send you a change request to your email.

 <div style="text-align: left;margin: 2%; width: 100%; background-color: #3d3f4117; padding: 10px;border-radius: 10px;" class="form form-inlne" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1200">

    <div style="width: 100%;">Your email:</div>
    <!-- Cambié a type="email" y agregué autocomplete="username" para que Chrome reconozca el campo -->
    <input style="height:auto;" type="email" id="email_recuperacion" name="email_recuperacion" class="form-control" placeholder="Enter Your Email*" required autocomplete="username" />

</div><br>

<div style="text-align: left;margin: 2%;width: 100%;" class="form form-inlne" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1200">
    <a onclick="send_email_forgot_password()" class="btn sub-btn" style="width: 100%;text-align: center;font-size: 18px;background-color: #f9cf40;">
        Send Now!
    </a>                
</div>

<div id="response_server"></div>

<br><hr>
<br>

<div style="text-align: left;margin: 2%;width: 100%;" class="form form-inlne" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1200">
    <a onclick="view_login_members()" class="btn sub-btn" style="width: 100%; text-align: center; font-size: 15px; background-color: transparent; border: 1px solid;">
        Back to login
    </a>                
</div>

`;

}




export function renderTablaPagos_Recibidos(res) {

  const container = document.getElementById("payment_list");

  if (!container) {
    console.warn("No existe el contenedor #payment_list");
    return;
  }

  // limpiar contenido previo
  container.innerHTML = "";

  // sin datos o error
  if (!res || !res.success || res.count === 0) {
    container.innerHTML = `
      <div class="col-12">
        <div class="snippet-box empty">
          <p>No payments received yet.</p>
        </div>
      </div>
    `;
    return;
  }

  res.pagos.forEach(pago => {

    const total = Number(pago.total_pago ?? 0).toLocaleString("en-US", {
      style: "currency",
      currency: "USD"
    });

    const fechaPago = pago.fecha_pago
      ? new Date(pago.fecha_pago).toLocaleDateString()
      : "—";

    const fechaVence = pago.fecha_vencimiento
      ? new Date(pago.fecha_vencimiento).toLocaleDateString()
      : "—";

    const html = `
      <div class="col-12 col-md-6 col-lg-4">
        <div class="snippet-box payment-card">

          <div class="payment-header">
            <strong>Payment received</strong>
          </div>

          <div class="payment-body">
            <p><span>Date:</span> ${fechaPago}</p>
            <p><span>Expires:</span> ${fechaVence}</p>
            <p><span>Amount:</span> ${total}</p>
            <p><span>Email:</span> ${pago.email ?? "-"}</p>
          </div>

          <div class="payment-footer">
            <small>Ref sale: ${pago.referencia_venta ?? "-"}</small><br>
            <small>Guide ref: ${pago.referencia_guia ?? "-"}</small>
          </div>

        </div>
      </div>
    `;

    container.insertAdjacentHTML("beforeend", html);
  });
}







// ======================================================
// ESTADO GLOBAL DEL CALENDARIO
// ======================================================
let calendarState = {
  year: new Date().getFullYear(),
  month: new Date().getMonth() // 0–11
};


// ======================================================
// AGRUPAR PAGOS POR DÍA
// ======================================================
function groupPagosByDay(pagos = []) {
  return pagos.reduce((acc, pago) => {
    const day = pago.fecha_pago.split(" ")[0]; // YYYY-MM-DD
    if (!acc[day]) acc[day] = [];
    acc[day].push(pago);
    return acc;
  }, {});
}


// ======================================================
// CARGAR PAGOS DESDE BACKEND POR MES
// ======================================================
let calendarLoading = false;

export async function loadPagosByMonth(year, month) {

  if (calendarLoading) return;

  setCalendarLoading(true);

  try {
    const res = await check_payments_recibidos(
      year,
      month + 1
    );

    let pagos = [];

    if (res && res.success && Array.isArray(res.pagos)) {
      pagos = res.pagos;
    }

    renderCalendarPagos(pagos, year, month);

    // 🧮 TOTAL DEL MES
    const totalVentas = calcularTotalPagos(pagos);

    // 💰 BOTÓN TOTAL + DETALLE
    renderTotalVentasButton(totalVentas, pagos, year, month);

  } catch (err) {

    console.error("Error loading payments by month", err);
    renderCalendarPagos([], year, month);
    renderTotalVentasButton(0, [], year, month);

  } finally {
    setCalendarLoading(false);
  }
}



function setCalendarLoading(isLoading) {
  calendarLoading = isLoading;

  const prev = document.getElementById("cal-prev");
  const next = document.getElementById("cal-next");
  const monthSel = document.getElementById("cal-month");
  const yearSel = document.getElementById("cal-year");

  [prev, next, monthSel, yearSel].forEach(el => {
    if (!el) return;
    el.disabled = isLoading;
    el.style.opacity = isLoading ? "0.5" : "1";
    el.style.pointerEvents = isLoading ? "none" : "auto";
  });
}


// ======================================================
// RENDER CALENDARIO
// ======================================================
export function renderCalendarPagos(pagos = [], year, month) {

  const container = document.getElementById("payment_list");
  if (!container) return;

  container.innerHTML = "";

  const pagosByDay = groupPagosByDay(pagos);

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

  let html = `


<div id="total_ventas_container"></div>

<div id="modal_pagos" class="modal">
  <div class="modal-content">
    <h3 class="modal-title"></h3>
    <div class="modal-body"></div>
    <button onclick="this.closest('.modal').classList.remove('show')">
      Cerrar
    </button>
  </div>
</div>


<br><br>


<div class="calendar-header">
  <button id="cal-prev">‹</button>

  <div class="calendar-selectors">
    <select id="cal-month">
      ${monthNames.map((m, i) =>
        `<option value="${i}" ${i === month ? "selected" : ""}>${m}</option>`
      ).join("")}
    </select>

    <select id="cal-year">
      ${Array.from({ length: 6 }, (_, i) => {
        const y = new Date().getFullYear() - 2 + i;
        return `<option value="${y}" ${y === year ? "selected" : ""}>${y}</option>`;
      }).join("")}
    </select>
  </div>

  <button id="cal-next">›</button>
</div>

<div class="calendar-grid">
`;

  // espacios vacíos inicio
  for (let i = 0; i < firstDay; i++) {
    html += `<div class="calendar-cell empty"></div>`;
  }

  // días del mes
  for (let day = 1; day <= daysInMonth; day++) {

    const dateStr = `${year}-${String(month + 1).padStart(2,"0")}-${String(day).padStart(2,"0")}`;

    const pagosDia = pagosByDay[dateStr] ?? [];
    const count = pagosDia.length;
    const countGuia = pagosDia.reduce((acc, p) => acc + (hasGuia(p) ? 1 : 0), 0);

    html += `
      <div class="calendar-cell ${count ? "has-payments" : ""}"
           data-date="${dateStr}">
        <span class="day-number">${day}</span>
        ${count ? `<span class="badge badge-total">${count}</span>` : ""}
        ${countGuia ? `<span class="badge badge-guia">G ${countGuia}</span>` : ""}
      </div>
    `;
  }

  html += `</div>`;
  container.innerHTML = html;

  // clicks por día
  container.querySelectorAll(".calendar-cell.has-payments").forEach(cell => {
    cell.addEventListener("click", () => {
      const date = cell.dataset.date;
      openPagosPopup(date, pagosByDay[date]);
    });
  });

  // navegación meses
  document.getElementById("cal-prev").onclick = () => {
    calendarState.month--;
    if (calendarState.month < 0) {
      calendarState.month = 11;
      calendarState.year--;
    }
    loadPagosByMonth(calendarState.year, calendarState.month);
  };

  document.getElementById("cal-next").onclick = () => {
    calendarState.month++;
    if (calendarState.month > 11) {
      calendarState.month = 0;
      calendarState.year++;
    }
    loadPagosByMonth(calendarState.year, calendarState.month);
  };


  document.getElementById("cal-month").onchange = (e) => {
  calendarState.month = parseInt(e.target.value, 10);
  loadPagosByMonth(calendarState.year, calendarState.month);
};

document.getElementById("cal-year").onchange = (e) => {
  calendarState.year = parseInt(e.target.value, 10);
  loadPagosByMonth(calendarState.year, calendarState.month);
};


}



function hasGuia(p) {
  const v = p?.referencia_guia;
  if (v === undefined || v === null) return false;
  const s = String(v).trim();
  if (!s || s.toLowerCase() === "null" || s === "0") return false;
  return true;
}



// ======================================================
// POPUP CON PAGOS DEL DÍA
// ======================================================
function openPagosPopup(dateStr, pagosDia = []) {

  const popup = document.createElement("div");
  popup.className = "calendar-popup";

  const renderRows = () => {
    return pagosDia.map((p, i) => {

      const esGuia = hasGuia(p);
      const userId = p.user_id ?? p.id_user ?? "-";

      const amount = Number(p.total_pago ?? 0);
      const planLabel = PLAN_LABELS?.[amount] ?? "Unknown plan";

      return `
        <tr class="${esGuia ? "tr-guia" : ""}">
          <td>${i + 1}</td>
          <td>${userId}</td>
          <td>${planLabel}</td>
          <td>
            ${esGuia
              ? `<span class="badge-origen guia">Guide</span>`
              : `<span class="badge-origen directa">Direct</span>`
            }
          </td>
          <td>${esGuia ? p.referencia_guia : "-"}</td>
          <td style="text-align:center;">
            <button class="details-btn" title="View details" data-index="${i}">
              🔍
            </button>
          </td>
        </tr>
      `;
    }).join("");
  };

  popup.innerHTML = `
    <div class="popup-content">
      <h3>Payments: ${dateStr}</h3>

      <div style="margin-top:8px; font-size:14px;">
        <strong>Total:</strong> ${pagosDia.length}
        &nbsp; | &nbsp;
        <strong>Reference:</strong> ${pagosDia.filter(hasGuia).length}
      </div>

      <div class="popup-table-wrapper">
        <table class="popup-table">
          <thead>
            <tr>
              <th>#</th>
              <th>User ID</th>
              <th>Plan</th>
              <th>Origin</th>
              <th>Reference</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            ${renderRows()}
          </tbody>
        </table>
      </div>

      <button class="close-btn" type="button">Close</button>
    </div>
  `;

  // -----------------------------------
  // Eventos detalle
  // -----------------------------------
  popup.querySelectorAll(".details-btn").forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const index = parseInt(btn.dataset.index, 10);
      openPagoDetallePopup(pagosDia[index]);
    });
  });

  popup.querySelector(".close-btn").addEventListener("click", () => popup.remove());

  popup.addEventListener("click", (e) => {
    if (e.target === popup) popup.remove();
  });

  document.body.appendChild(popup);
}




function calcularTotalPagos(pagos = []) {

  const total = pagos.reduce((sum, p) => {
    const monto = parseFloat(p.total_pago ?? 0);
    return sum + (isNaN(monto) ? 0 : monto);
  }, 0);

  const comisionPorcentaje = Number(store.session.user.comision ?? 0);

  // comisión = total * (porcentaje / 100)
  const comision = total * (comisionPorcentaje / 100);

  return comision;
}






function renderTotalVentasButton(total, pagos, year, month) {

  const container = document.getElementById("total_ventas_container");
  if (!container) return;

  container.innerHTML = `
    <button class="btn-total-ventas" type="button" style="background-color: antiquewhite;
    padding: 20px;
    border-radius: 10px;">
      💰 Total ${year}-${String(month + 1).padStart(2, "0")}: 
      <strong>$${total.toFixed(2)}</strong>
    </button>
  `;

  container.querySelector("button").addEventListener("click", () => {
    abrirDetallePagos(pagos, year, month);
  });
}




function abrirDetallePagos(pagos = [], year, month) {

  const modal = document.getElementById("modal_pagos");
  const body  = modal.querySelector(".modal-body");

  body.innerHTML = pagos.length
    ? pagos.map(p => `
        <div class="pago-item">
          <strong>${p.fecha}</strong> — $${p.total_pago}
        </div>
      `).join("")
    : `<p>No hay pagos registrados</p>`;

  modal.querySelector(".modal-title").textContent =
    `Pagos ${year}-${String(month + 1).padStart(2, "0")}`;

  modal.classList.add("show");
}



// ===== FUNCIÓN =====
async function openPagoDetallePopup(p) {

  let clienteNombre = "Unknown";

  // -----------------------------
  // Cargar datos del cliente
  // -----------------------------
  try {
    const res = await detalles_cliente(p.user_id);

    if (res && res.success && res.data) {
      clienteNombre = res.data.nombre ?? clienteNombre;
    }

  } catch (err) {
    console.error("Error loading client data", err);
  }

  // -----------------------------
  // Flags y datos base
  // -----------------------------
  const esGuia = hasGuia(p);

  const amount = Number(p.total_pago ?? 0);
  const planLabel = PLAN_LABELS?.[amount] ?? `${amount} MXN`;

  // -----------------------------
  // Popup
  // -----------------------------
  const popup = document.createElement("div");
  popup.className = "calendar-popup";

  popup.innerHTML = `
    <div class="popup-content popup-detail" style="max-width:420px;">
      <h3>Payment Details</h3>

      <div class="detail-list">

        <div class="detail-row">
          <span class="label">Client</span>
          <span class="value">${clienteNombre}</span>
        </div>

        <div class="detail-row">
          <span class="label">User ID</span>
          <span class="value">${p.user_id ?? "-"}</span>
        </div>

        <div class="detail-row">
          <span class="label">Payment Date</span>
          <span class="value">${p.fecha_pago ?? p.created_at ?? "-"}</span>
        </div>

        <div class="detail-row">
          <span class="label">Plan</span>
          <span class="value">${planLabel}</span>
        </div>

        <div class="detail-row">
          <span class="label">Origin</span>
          <span class="value">${esGuia ? "Guide" : "Direct"}</span>
        </div>

        ${esGuia ? `
          <div class="detail-row">
            <span class="label">Reference</span>
            <span class="value">${p.referencia_guia ?? "-"}</span>
          </div>
        ` : ``}

      </div>

      <button class="close-btn" type="button">Close</button>
    </div>
  `;

  // -----------------------------
  // Eventos
  // -----------------------------
  popup.querySelector(".close-btn").addEventListener("click", () => popup.remove());

  popup.addEventListener("click", (e) => {
    if (e.target === popup) popup.remove();
  });

  document.body.appendChild(popup);
}















export function qr_generator() {

  // ===============================
  // Evitar abrir más de uno
  // ===============================
  if (document.getElementById("qrGuidePopup")) return;

  // ===============================
  // OVERLAY
  // ===============================
  const overlay = document.createElement("div");
  overlay.id = "qrGuidePopup";

  Object.assign(overlay.style, {
    position: "fixed",
    inset: "0",
    background: "rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "10000",
    padding: "16px"
  });

  // ===============================
  // MODAL
  // ===============================
  const modal = document.createElement("div");

  Object.assign(modal.style, {
    width: "min(420px, 100%)",
    height: "min(80vh, 520px)",
    background: "#fff",
    borderRadius: "16px",
    padding: "16px",
    boxShadow: "0 18px 50px rgba(0,0,0,0.25)",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
    display: "flex",
    flexDirection: "column"
  });

  // ===============================
  // TOP SECTION (INPUT FIJO)
  // ===============================
  const title = document.createElement("h5");
  title.textContent = "Need more QR codes for your collaborators?";
  Object.assign(title.style, {
    margin: "0 0 10px 0",
    fontSize: "18px"
  });

  const label = document.createElement("label");
  label.textContent = "Put guide name as reference";
  Object.assign(label.style, {
    display: "block",
    marginBottom: "6px",
    fontSize: "14px"
  });

  const input = document.createElement("input");
  input.type = "text";
  input.placeholder = "e.g. Carlos Ramirez";

  Object.assign(input.style, {
    width: "100%",
    padding: "10px 12px",
    borderRadius: "10px",
    border: "1px solid rgba(0,0,0,0.2)",
    fontSize: "14px"
  });

  const topSection = document.createElement("div");
  Object.assign(topSection.style, {
    marginBottom: "12px"
  });

  topSection.appendChild(title);
  topSection.appendChild(label);
  topSection.appendChild(input);

  // ===============================
  // LIST SECTION (SCROLL)
  // ===============================
  const listSection = document.createElement("div");

  Object.assign(listSection.style, {
    flex: "1",
    overflowY: "auto",
    borderTop: "1px solid rgba(0,0,0,0.08)",
    borderBottom: "1px solid rgba(0,0,0,0.08)",
    padding: "10px 6px",
    marginBottom: "12px"
  });

 

  
    const qrListContainer = document.createElement("div");
    qrListContainer.id = "qrGuideList";

    Object.assign(qrListContainer.style, {
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    });

    listSection.appendChild(qrListContainer);

  // ===============================
  // ACTIONS (BOTTOM FIXED)
  // ===============================
  const actions = document.createElement("div");

  Object.assign(actions.style, {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "auto"
  });

  const btnCancel = document.createElement("button");
  btnCancel.textContent = "Cancel";

  Object.assign(btnCancel.style, {
    padding: "10px 14px",
    borderRadius: "10px",
    border: "1px solid rgba(0,0,0,0.18)",
    background: "#fff",
    cursor: "pointer"
  });

  const btnAccept = document.createElement("button");
  btnAccept.textContent = "Add QR";

  Object.assign(btnAccept.style, {
    padding: "10px 14px",
    borderRadius: "10px",
    border: "0",
    background: "#111",
    color: "#fff",
    cursor: "pointer"
  });

  actions.appendChild(btnCancel);
  actions.appendChild(btnAccept);

  // ===============================
  // ENSAMBLADO
  // ===============================
  modal.appendChild(topSection);
  modal.appendChild(listSection);
  modal.appendChild(actions);
  overlay.appendChild(modal);
  document.body.appendChild(overlay);

  // ===============================
  // FUNCIONES
  // ===============================
  const close = () => {
    window.removeEventListener("keydown", onKeyDown);
    overlay.remove();
  };

  const accept = async () => {
    const guideName = input.value.trim();

    // 🔒 solo letras (a–z, A–Z), sin espacios, 1 a 8 caracteres
    const regex = /^[A-Za-z0-9]{1,14}$/;

    if (!regex.test(guideName)) {

      alertas({
              type: "error",
              title: "Error",
              message: "Guide name must contain only letters and numbers, with no spaces or special characters, and be up to 14 characters long",
              buttonText: "Close"
            });

      input.focus();
      return;
    }

    if (!guideName) {
       alertas({
              type: "error",
              title: "Error",
              message: "Please enter a guide name",
              buttonText: "Close"
            });
      input.focus();
      return;
    }

    // 👇 Aquí conectas tu backend real
    const res = await new_qr_guide_reference(guideName);

    console.log("NEW QR GUIDE:", guideName);

        (async () => {
        const guides = await get_qr_guides(); // backend
        renderQrGuideList(guides);
      })();

  };




  const onKeyDown = (e) => {
    if (e.key === "Escape") close();
    if (e.key === "Enter") accept();
  };

  // ===============================
  // EVENTOS
  // ===============================
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) close();
  });

  btnCancel.addEventListener("click", close);
  btnAccept.addEventListener("click", accept);
  window.addEventListener("keydown", onKeyDown);

  setTimeout(() => input.focus(), 0);


  (async () => {
    const guides = await get_qr_guides(); // backend
    renderQrGuideList(guides);
  })();



}




function renderQrGuideList(guides = []) {

  const container = document.getElementById("qrGuideList");
  if (!container) return;

  container.innerHTML = "";

  if (!guides.length) {
    const empty = document.createElement("div");
    empty.textContent = "No QR guides found";
    Object.assign(empty.style, {
      padding: "14px",
      textAlign: "center",
      color: "#777",
      fontSize: "14px"
    });
    container.appendChild(empty);
    return;
  }

  guides.forEach(g => {

    const item = document.createElement("div");
    item.id = `qr-guide-${g.id}`;
    item.textContent = `📱 ${g.name_guide_reference}`;

    Object.assign(item.style, {
      padding: "10px 12px",
      borderRadius: "10px",
      background: "#f5f5f5",
      fontSize: "14px",
      cursor: "pointer"
    });

    item.addEventListener("mouseenter", () => {
      item.style.background = "#eee";
    });

    item.addEventListener("mouseleave", () => {
      item.style.background = "#f5f5f5";
    });

    item.addEventListener("click", () => {

     
          const qrUrl =
            store.URL_PHP +
            "?reference_id_member=" + store.session.user.key_user +
            "&guide_reference=" + g.name_guide_reference;

          console.log("Selected guide:", g);
          console.log("QR URL:", qrUrl);

          openQrPopup(qrUrl, g.name_guide_reference);

    });

    container.appendChild(item);
  });
}


function openQrPopup(qrUrl, guideName) {

  // ===============================
  // OVERLAY
  // ===============================
  const overlay = document.createElement("div");

  Object.assign(overlay.style, {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 99999
  });

  // ===============================
  // POPUP
  // ===============================
  const popup = document.createElement("div");

  Object.assign(popup.style, {
    background: "#fff",
    padding: "20px",
    borderRadius: "16px",
    width: "300px",
    textAlign: "center",
    position: "relative"
  });

  // ===============================
  // TITLE
  // ===============================
  const title = document.createElement("h4");
  title.textContent = `QR – ${guideName}`;
  title.style.marginBottom = "12px";

  // ===============================
  // CANVAS QR
  // ===============================
  const canvas = document.createElement("canvas");
  canvas.id = `qr_canvas_${Date.now()}_${Math.floor(Math.random() * 10000)}`;

  Object.assign(canvas.style, {
    width: "220px",
    height: "220px",
    marginBottom: "12px",
    cursor: "pointer" // 👈 indica que es clickeable
  });

  // ===============================
  // DESCARGAR AL CLICK
  // ===============================
  canvas.addEventListener("click", () => {
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = `QR_${guideName || "code"}.png`;
    link.click();
  });

  // ===============================
  // CLOSE BUTTON
  // ===============================
  const closeBtn = document.createElement("button");
  closeBtn.textContent = "Close";

  Object.assign(closeBtn.style, {
    padding: "8px 14px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    background: "#111",
    color: "#fff"
  });

  closeBtn.onclick = () => overlay.remove();

  // ===============================
  // BUILD
  // ===============================
  popup.appendChild(title);
  popup.appendChild(canvas);
  popup.appendChild(closeBtn);
  overlay.appendChild(popup);
  document.body.appendChild(overlay);

  // ===============================
  // GENERATE QR
  // ===============================
  makeQR(qrUrl, canvas.id);
}




export function payments_config() {

  (async () => {

    const res = await view_details_memebrs(store.session.user.key_user);
    const accepted = Number(res?.payments_accepted ?? 0);

    // -------------------------------
    // TODOS LOS PLANES DISPONIBLES
    // -------------------------------
    const allPlans = [199, 499, 899];

    // -------------------------------
    // MAPEO BD → CHECKS ACTIVOS
    // -------------------------------
    const acceptedMap = {
      0: [199, 499, 899],
      1: [499],
      2: [199, 499],
      3: [899],
      4: [199],
      5: [199, 899],
      6: [499, 899]
    };

    const activePlans = acceptedMap[accepted] || [];

    // -------------------------------
    // OVERLAY
    // -------------------------------
    const overlay = document.createElement("div");
    Object.assign(overlay.style, {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,.6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 99999
    });

    // -------------------------------
    // POPUP
    // -------------------------------
    const popup = document.createElement("div");
    Object.assign(popup.style, {
      background: "#fff",
      borderRadius: "16px",
      width: "340px",
      padding: "20px",
      fontFamily: "system-ui"
    });

    popup.innerHTML = `
      <h3 style="margin-top:0">Accepted Payments</h3>
      <p style="font-size:14px;color:#666">
        Enable or disable available subscription plans.
      </p>

      <form id="paymentsForm" style="margin-top:15px">
        ${allPlans.map(price => `
          <label style="display:flex;align-items:center;gap:10px;margin-bottom:12px;cursor:pointer">
            <input 
              type="checkbox"
              value="${price}"
              ${activePlans.includes(price) ? "checked" : ""}
            >
            <strong>$${price}</strong>
          </label>
        `).join("")}
      </form>

      <div style="margin-top:20px;text-align:right">
        <button id="closePayments"
          style="margin-right:10px;padding:8px 14px;border-radius:8px;border:0;background:#ccc">
          Cancel
        </button>
        <button id="savePayments"
          style="padding:8px 14px;border-radius:8px;border:0;background:#000;color:#fff">
          Save
        </button>
      </div>
    `;

    overlay.appendChild(popup);
    document.body.appendChild(overlay);

    // -------------------------------
    // EVENTS
    // -------------------------------
    popup.querySelector("#closePayments").onclick = () => overlay.remove();

    popup.querySelector("#savePayments").onclick = () => {

        const selected = [...popup.querySelectorAll("input[type='checkbox']:checked")]
          .map(cb => Number(cb.value));

        const paymentsAccepted = getPaymentsAcceptedFromSelection(selected);

        if (paymentsAccepted === null) {
          alert("Invalid payment combination");
          return;
        }

        console.log("payments_accepted =", paymentsAccepted);

        // 👉 aquí ya mandas SOLO EL NÚMERO al backend
         update_payments_config(paymentsAccepted);

        overlay.remove();
      };

  })();

}




function getPaymentsAcceptedFromSelection(selected = []) {

  const acceptedMap = {
    0: [199, 499, 899],
    1: [499],
    2: [199, 499],
    3: [899],
    4: [199],
    5: [199, 899],
    6: [499, 899]
  };

  const normalize = arr => arr.map(Number).sort((a, b) => a - b).join(",");

  const selectedKey = normalize(selected);

  for (const key in acceptedMap) {
    if (normalize(acceptedMap[key]) === selectedKey) {
      return Number(key);
    }
  }

  return null; // ❌ combinación inválida
}



window.login_members = login_members;
window.qr_generator = qr_generator;
window.payments_config = payments_config;
window.forgot_password_member = forgot_password_member;
window.view_login_members = view_login_members;
window.send_email_forgot_password = send_email_forgot_password;
